import {
  operationOnPhoto,
  getParticularPhotoDetails,
  getNearbyPhotos,
  _top_image_section
} from '../../../api'
import common from '../common/common'
import axios from 'axios'
import auth from '../auth/auth'
import router from '../../../router'
const state = {
  nearBy: [],
  fetchingNearby: false,
  license: {}
}
const getters = {
  nearBy: state => state.nearBy,
  fetchingNearby: state => state.fetchingNearby,
  lisense: state => state.license
}
const mutations = {
  async getNearbyPhotos(state2, payload) {
    if(payload.startAt === 0) {
      state.nearBy = []
    }
    let payloadForAPI = payload
    state.fetchingNearby = true
    let x1 = await axios.get(getNearbyPhotos(payloadForAPI))
    state.fetchingNearby = false
    for(let i in x1.data.nearbyPhotos) {
      state.nearBy.push(x1.data.nearbyPhotos[i])
    }
  },


  goToImageDetMap(state2, payload) {
    common.state.imageDetParticular = payload.image
    let caption = payload.caption
    let id = payload.image.id === undefined?payload.image.photoId: payload.image.id
    let isLiked = payload.image.isLiked
    if(!router.currentRoute.fullPath.includes('imageDetails')) {
      localStorage.setItem('path', router.currentRoute.fullPath)
    }
    if(!isLiked) {
      window.thisOfApp.$modal.show('ask-to-add-to-wishlist')
      localStorage.removeItem('openDirections')
    }
    else if(isLiked) {
      localStorage.setItem('openDirections', JSON.stringify(true))
      router.push(`/id/${id}?inapp=true`)
    }
  }
}
const actions = {
  _top_image_section(state2, payload) {
    return new Promise(async (resolve)=> {
      let {data} = await axios.get(_top_image_section(payload))
      resolve(data)
    })
  },
  operationOnPhoto (state2, payload) {
    return new Promise(async (resolve)=> {
      if(payload.uid === auth.state.user.uid) {
        payload.isCron = false
        if(auth.state.isLoggedIn) {
          let x1 = await axios.get(operationOnPhoto, {
            params: payload
          })
          if(payload.operation === 'like' && x1.data.status === 'added') {
            if(JSON.parse(localStorage.getItem('firstLIke')) != true) {
              localStorage.setItem('firstLIke',JSON.stringify(true))
            }
          }

          if(payload.operation === 'checkin' && x1.data.status === 'added') {
            if(JSON.parse(localStorage.getItem('firstCheckin')) != true) {
              localStorage.setItem('firstCheckin',JSON.stringify(true))
            }
          }
          resolve(x1.data.status)
        }
      }
    })
  },
  getImageDetails(state2, payload) {
    payload.isCron = false
    return new Promise((resolve) => {
      axios.get(getParticularPhotoDetails, {
        params: payload
      }).then((res) => {
        state.license = res.data.license
        state.license.photoSourceLink = res.data.photoSourceLink
        let data = res.data
        resolve(data)
      })
    })
  }
}
export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/imageDetails/imageDetails.js